import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const translationContract = c.router(
  {
    translate: {
      method: 'POST',
      path: '/',
      responses: {
        200: z.object({
          items: z.array(z.string()),
        }),
      },
      body: z.object({
        inputLanguage: z.string().optional(),
        outputLanguage: z.string(),
        items: z.array(z.string()),
      }),
      summary: 'Translates an ordered list of text items into desired language',
    },
  },
  {
    pathPrefix: '/translation',
  },
);
